// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"5a488153","70":"595829af","82":"4a209e4c","326":"0fcf56c9","453":"65062146","573":"09205ee1","643":"7328bc5f","755":"b797f126","849":"768512b3","918":"d13d34f9","983":"16347a8f"}[chunkId] + ".chunk.js";
};